export enum PhotoViewerPromoCase {
  /**
   * Смахивание, например, справа налево,
   * при первом показе промки в фотовьювере.
   *
   * Смахивается только сама промка, без фотки.
   */
  next = 'next',
  /**
   * Смахивание next произошло.
   */
  nextFinished = 'nextFinished',
  /**
   * Показ промки при обратном переходе.
   * Промка едет вместе с фоткой.
   */
  prevoius = 'prevoius',
  /**
   * Докрутили промку вместе с фоткой в обратном порядке.
   * Промка готова к смахиванию.
   */
  prevoiusFinished = 'prevoiusFinished',
}
